import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const FillDataPopup = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.fillData}>
      <h2 dangerouslySetInnerHTML={{__html: t("popup.fill_data.subtitle")}} />
    </div>
  );
};
